import React, { useEffect, useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { LogoHorizontal } from "./Logo";
import { navLinks, companyInfo } from "../mock";
import { Button } from "./ui/button";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      {/* Top bar */}
      <div className="hidden md:block bg-brand-900 text-brand-100 text-[13px]">
        <div className="max-w-7xl mx-auto px-6 py-2 flex items-center justify-between">
          <div className="flex items-center gap-6">
            <a
              href={`tel:${companyInfo.phone.replace(/\s/g, "")}`}
              className="flex items-center gap-2 hover:text-white transition-colors"
            >
              <Phone className="w-3.5 h-3.5" />
              {companyInfo.phone}
            </a>
            <a
              href={`mailto:${companyInfo.email}`}
              className="hover:text-white transition-colors"
            >
              {companyInfo.email}
            </a>
          </div>
          <div className="text-brand-200">{companyInfo.legal}</div>
        </div>
      </div>

      <header
        className={`sticky top-0 z-50 transition-all duration-300 ${
          scrolled
            ? "bg-white/90 backdrop-blur-md shadow-sm"
            : "bg-white"
        }`}
      >
        <div className="max-w-7xl mx-auto px-6 flex items-center justify-between h-20">
          <a href="/#start" aria-label="Startseite">
            <LogoHorizontal />
          </a>

          <nav className="hidden lg:flex items-center gap-7">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                className="text-[14px] font-medium text-brand-900 hover:text-accent2 transition-colors relative group"
              >
                {l.label}
                <span className="absolute -bottom-1 left-0 w-0 h-[2px] bg-accent2 transition-all duration-300 group-hover:w-full" />
              </a>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-3">
            <Button
              asChild
              className="bg-brand-900 hover:bg-brand-800 text-white rounded-full px-5 h-11"
            >
              <a href="/#contact">Beratungsgespräch</a>
            </Button>
          </div>

          <button
            className="lg:hidden p-2 text-brand-900"
            onClick={() => setOpen(!open)}
            aria-label="Menü"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile menu */}
        {open && (
          <div className="lg:hidden border-t border-brand-100 bg-white">
            <div className="px-6 py-4 flex flex-col gap-4">
              {navLinks.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="text-brand-900 font-medium py-2 border-b border-brand-50"
                >
                  {l.label}
                </a>
              ))}
              <Button
                asChild
                className="bg-brand-900 hover:bg-brand-800 text-white rounded-full mt-2"
              >
                <a href="/#contact" onClick={() => setOpen(false)}>
                  Beratungsgespräch vereinbaren
                </a>
              </Button>
            </div>
          </div>
        )}
      </header>
    </>
  );
};

export default Navbar;
